import React, {useEffect, useReducer, Image} from 'react';
import './App.css';
import GeneralList from './list';
import GeneralGrid from './grid';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import HeatPumpIcon from '@mui/icons-material/LocalDrink';
import ChargingStationSmallIcon from '@mui/icons-material/ChargingStation';
import ChargingStationLargeIcon from '@mui/icons-material/EvStation';
import Fan1Icon from '@mui/icons-material/Air';
import Fan2Icon from '@mui/icons-material/WindPower';
import HotWaterGasIcon from '@mui/icons-material/Water';
import AirFryerIcon from '@mui/icons-material/Stadium';
import DishwasherIcon from '@mui/icons-material/DiningSharp';
import CoffeeMakerIcon from '@mui/icons-material/CoffeeMaker';
import ElectricOvenIcon from '@mui/icons-material/ViewDay';
import DryerIcon from '@mui/icons-material/DryCleaning';  
import WashingMachineIcon from '@mui/icons-material/LocalLaundryService';  
import IronIcon from '@mui/icons-material/Iron'; 
import HairDryerIcon from '@mui/icons-material/Sports';
import DesktopComputerIcon from '@mui/icons-material/DesktopWindows';
import TabletIcon from '@mui/icons-material/TabletMac';
import MobileIcon from '@mui/icons-material/MobileFriendly';
import GamingConsoleIcon from '@mui/icons-material/SportsEsports';
import LaptopComputerIcon from '@mui/icons-material/Laptop';
import ModemIcon from '@mui/icons-material/Router';
import SoundSytemIcon from '@mui/icons-material/VolumeUp';
import TVIcon from '@mui/icons-material/Tv';
import AirCompressorIcon from '@mui/icons-material/Upcoming';
import PowerIcon from '@mui/icons-material/Power';
import WelderIcon from '@mui/icons-material/AutoFixNormal';
import GrinderIcon from '@mui/icons-material/CircleTwoTone';
import LightsIcon from '@mui/icons-material/Light';
import PortableHeaterIcon from '@mui/icons-material/HeatPump';
import PressurePumpIcon from '@mui/icons-material/WaterDamage';
import VacumeCleanerIcon from '@mui/icons-material/CleaningServices';
import WoodHeaterIcon from '@mui/icons-material/Whatshot';
import ElectricStoveTopLargeIcon from '@mui/icons-material/ViewSidebar';
import ElectricStoveTopSmallIcon from '@mui/icons-material/Bento';
import FreezerChestIcon from '@mui/icons-material/Thermostat';
import FridgeIcon from '@mui/icons-material/Kitchen';
import FridgeMiniIcon from '@mui/icons-material/WineBar';
import GasIcon from '@mui/icons-material/PropaneTank';
import { v4 as uuidv4 } from 'uuid'; // Assuming you have the 'uuid' library instal
import LOGO from './whitelogo.png';

const defaultGeneralItems = [
  { id: uuidv4(), icon: <AcUnitIcon />, primary: 'Air Conditioner - Ducted', isSelected: false, quantity : 1,  runningWatts: 4000, hoursPerDay : 5 },
  { id: uuidv4(), icon: <AcUnitIcon />, primary: 'Air Conditioner - Large', isSelected: false ,  quantity : 1, runningWatts: 1800, hoursPerDay : 5 },
  { id: uuidv4(), icon: <AcUnitIcon />, primary: 'Air Conditioner - Small', isSelected: false , quantity : 1, runningWatts: 850, hoursPerDay : 5 },
  { id: uuidv4(), icon: <HeatPumpIcon />, primary: 'Air Conditioner - Swampy', isSelected: false , quantity : 1, runningWatts: 2000, hoursPerDay : 4 },
  { id: uuidv4(), icon: <ChargingStationLargeIcon />, primary: 'Electric Vehicle Charger - Large', quantity : 1, isSelected: false , runningWatts: 7000, hoursPerDay : 5 },
  { id: uuidv4(), icon: <ChargingStationSmallIcon />, primary: 'Electric Vehicle Charger - Small', quantity : 1, isSelected: false , runningWatts: 3000, hoursPerDay : 5 },
  { id: uuidv4(), icon: <Fan1Icon />, primary: 'Fan - Ceiling', isSelected: false , quantity : 1, runningWatts: 40, hoursPerDay : 5  },
  { id: uuidv4(), icon: <Fan2Icon />, primary: 'Fan - Pedestal', isSelected: false, quantity : 1, runningWatts: 30, hoursPerDay : 2 },
  { id: uuidv4(), icon: <HotWaterGasIcon />, primary: 'Hot Water - Electric 320 Litre', isSelected: false, quantity : 1, runningWatts: 3600, hoursPerDay : 4 },
  { id: uuidv4(), icon: <HotWaterGasIcon />, primary: 'Hot Water - Electric 270 Litre', isSelected: false, quantity : 1, runningWatts: 840, hoursPerDay : 4.5 },
  { id: uuidv4(), icon: <HotWaterGasIcon />, primary: 'Hot Water - Gas', isSelected: false, quantity : 1, runningWatts: 50, hoursPerDay : 4 },
  { id: uuidv4(), icon: <LightsIcon />, primary: 'Lights', isSelected: false, quantity : 12, runningWatts: 11, hoursPerDay : 8 },
  { id: uuidv4(), icon: <PortableHeaterIcon />, primary: 'Portable Heater', isSelected: false, quantity : 1, runningWatts: 2400, hoursPerDay : 3 },
  { id: uuidv4(), icon: <PressurePumpIcon />, primary: 'Pressure Pump', isSelected: false, quantity : 1, runningWatts: 650, hoursPerDay : 1 },
  { id: uuidv4(), icon: <VacumeCleanerIcon />, primary: 'Vacuum Cleaner', isSelected: false, quantity : 1, runningWatts: 140, hoursPerDay : 0.25 },
  { id: uuidv4(), icon: <WoodHeaterIcon />, primary: 'Wood Heater', isSelected: false, quantity : 1, runningWatts: 60, hoursPerDay : 7 },
];

const defaultKitchenItems = [
  { id: uuidv4(), icon: <AirFryerIcon />, primary: 'Air Fryer', isSelected: false, quantity : 1,  runningWatts: 1500, hoursPerDay : .5 },
  { id: uuidv4(), icon: <CoffeeMakerIcon />, primary: 'Coffee Maker', isSelected: false, quantity : 1,  runningWatts: 1350, hoursPerDay : 5 },
  { id: uuidv4(), icon: <DishwasherIcon />, primary: 'Dishwasher', isSelected: false, quantity : 1,  runningWatts: 1800, hoursPerDay : 1 },
  { id: uuidv4(), icon: <ElectricOvenIcon />, primary: 'Electric Oven', isSelected: false, quantity : 1,  runningWatts: 3400, hoursPerDay : 1 },
  { id: uuidv4(), icon: <ElectricStoveTopLargeIcon />, primary: 'Electric  Stovetop - Large', isSelected: false, quantity : 1,  runningWatts: 3400, hoursPerDay : 1 },
  { id: uuidv4(), icon: <ElectricStoveTopSmallIcon />, primary: 'Electric  Stovetop - Small', isSelected: false, quantity : 1,  runningWatts: 3400, hoursPerDay : 1 },
  { id: uuidv4(), icon: <FreezerChestIcon />, primary: 'Freezer - Chest', isSelected: false, quantity : 1,  runningWatts: 3400, hoursPerDay : 1 },
  { id: uuidv4(), icon: <FridgeIcon />, primary: 'Fridge/Freezer - Large', isSelected: false, quantity : 1,  runningWatts: 3400, hoursPerDay : 1 },
  { id: uuidv4(), icon: <FridgeIcon />, primary: 'Fridge/Freezer - Small', isSelected: false, quantity : 1,  runningWatts: 3400, hoursPerDay : 1 },
  { id: uuidv4(), icon: <FridgeMiniIcon />, primary: 'Fridge - Beer/Wine', isSelected: false, quantity : 1,  runningWatts: 3400, hoursPerDay : 1 },
  { id: uuidv4(), icon: <GasIcon />, primary: 'Gas - Cooktop', isSelected: false, quantity : 1,  runningWatts: 3400, hoursPerDay : 1 },
  { id: uuidv4(), icon: <GasIcon />, primary: 'Gas - Oven', isSelected: false, quantity : 1,  runningWatts: 3400, hoursPerDay : 1 },
 ];

const defaultLaundryItems = [
  { id: uuidv4(), icon: <DryerIcon />, primary: 'Dryer', isSelected: false, quantity : 1,  runningWatts: 2500, hoursPerDay : 1 },
  { id: uuidv4(), icon: <HairDryerIcon />, primary: 'Hair Dryer', isSelected: false, quantity : 1,  runningWatts: 2000, hoursPerDay : .1 },
  { id: uuidv4(), icon: <IronIcon />, primary: 'Iron', isSelected: false, quantity : 1,  runningWatts: 1800, hoursPerDay : .5 },
  { id: uuidv4(), icon: <WashingMachineIcon />, primary: 'Washing Machine', isSelected: false, quantity : 1,  runningWatts: 1800, hoursPerDay : 1 },
];

const defaultTech = [
  { id: uuidv4(), icon: <DesktopComputerIcon />, primary: 'Desktop Computer', isSelected: false, quantity : 1,  runningWatts: 135, hoursPerDay : 3 },
  { id: uuidv4(), icon: <GamingConsoleIcon />, primary: 'Gaming Console', isSelected: false, quantity : 1,  runningWatts: 140, hoursPerDay : 6 },
  { id: uuidv4(), icon: <LaptopComputerIcon />, primary: 'Laptop (Charging)', isSelected: false, quantity : 1,  runningWatts: 90, hoursPerDay : 6 },
  { id: uuidv4(), icon: <TabletIcon />, primary: ' Tablet (Charging)', isSelected: false, quantity : 1,  runningWatts: 6, hoursPerDay : 4 },
  { id: uuidv4(), icon: <MobileIcon />, primary: 'Mobile (Charging)', isSelected: false, quantity : 1,  runningWatts: 2, hoursPerDay : 4 },
  { id: uuidv4(), icon: <ModemIcon />, primary: 'Modem / Internet', isSelected: false, quantity : 1,  runningWatts: 10, hoursPerDay : 24 },
  { id: uuidv4(), icon: <SoundSytemIcon />, primary: 'Sound System', isSelected: false, quantity : 1,  runningWatts: 60, hoursPerDay : 4 },
  { id: uuidv4(), icon: <TVIcon />, primary: 'TV', isSelected: false, quantity : 1,  runningWatts: 90, hoursPerDay : 4 },
];

const defaultPowertools = [
  { id: uuidv4(), icon: <AirCompressorIcon />, primary: 'Air Compressor', isSelected: false, quantity : 1,  runningWatts: 3300, hoursPerDay : 0.2 },
  { id: uuidv4(), icon: <GrinderIcon />, primary: 'Angle Grinder', isSelected: false, quantity : 1,  runningWatts: 2000, hoursPerDay : 0.1 },
  { id: uuidv4(), icon: <PowerIcon />, primary: 'Charging for Common Power Tools', isSelected: false, quantity : 1,  runningWatts: 240, hoursPerDay : 1 },
  { id: uuidv4(), icon: <WelderIcon />, primary: 'Welder - Medium', isSelected: false, quantity : 1,  runningWatts: 6000, hoursPerDay : 0.1 },
];

function reducer(state, action) {

  switch (action.type) {
    case 'set_household': {

      const newItem = {...state, selectedGeneralItems : [...action.payload]}


      return {
        ...newItem,

      };
    }
    case 'set_kitchen': {

      const newItem = {...state, selectedKitchenItems : [...action.payload]}


      return {
        ...newItem,
      };
    }
    case 'set_laundry': {
      const newItem = {...state, selectedLaundryItems : [...action.payload]}

      return {
        ...newItem,
      };
    }
    case 'set_tech': {
      const newItem = {...state, selectedTechItems : [...action.payload]}

      return {
        ...newItem,
      };
    }
    case 'set_power': {
      const newItem = {...state, selectedPowertoolsItems : [...action.payload]}


      return {
        ...newItem,

      };
    }
    case 'set_custom': {
      const newItem = {...state, customItems : [...action.payload]}
      return {
        ...newItem,

      };
    }
    case 'reset_all': {
      const newItem = {selectedGeneralItems : [] , selectedKitchenItems: [], selectedLaundryItems: [], selectedTechItems: [], selectedPowertoolsItems: [] , customItems : []}


      return {
        ...newItem,

      };
    }
  }
  throw Error('Unknown action: ' + action.type);
}

function App() {

  const [state, dispatch] = useReducer(reducer, { selectedGeneralItems: [], selectedKitchenItems: [] , selectedLaundryItems: [], selectedTechItems: [], selectedPowertoolsItems: [], customItems : []});

 
  return (
    <div className="App">
        <div className="InnerContainer">
    
 
      <div className="App-header">
      <div className="Step-header">  
      <div style={{marginLeft: 5, marginRight: 5}}><h4>1.  Select all appliances you intend to use</h4></div>       
        <div style={{marginLeft: 5, marginRight: 5}}>You can reset each category individually using the Reset button</div>
        <div style={{marginTop: 25,  marginLeft: 5, marginRight: 5}}>Tip! Select again to increase the quanity</div>
      </div>
      <GeneralList title={'General Household'} showList={false} inputItems={state.selectedGeneralItems} defaultItems={defaultGeneralItems} setTotal={(list) => dispatch({type:'set_household', payload : list})}></GeneralList>
      <GeneralList title={'Kitchen'} showList={false} inputItems={state.selectedKitchenItems} defaultItems={defaultKitchenItems} setTotal={(list) => dispatch({type:'set_kitchen', payload : list})}></GeneralList>
      <GeneralList title={'Laundry'} showList={false} inputItems={state.selectedLaundryItems} defaultItems={defaultLaundryItems} setTotal={(list) => dispatch({type:'set_laundry', payload : list})}></GeneralList>
      <GeneralList title={'Technology'} showList={false} inputItems={state.selectedTechItems} defaultItems={defaultTech} setTotal={(list) => dispatch({type:'set_tech', payload : list})}></GeneralList>
      <GeneralList title={'Power Tools'} showList={false} inputItems={state.selectedPowertoolsItems} defaultItems={defaultPowertools} setTotal={(list) => dispatch({type:'set_power', payload : list})}></GeneralList>
      <div className="Step-header"> 
      <div style={{marginLeft: 5, marginRight: 5}}><h4>2.  How often do you use the appliances</h4></div>        
        <div style={{marginLeft: 5, marginRight: 5}}>Change the hours per day to reflect how often you use each appliance.</div>
        <div style={{marginTop: 25, marginLeft: 5, marginRight: 5}}>Use "Add Custom" to add any other applicances not listed above.</div>
      </div>
      <GeneralGrid title={'Total'} showList={false} inputItems={state} dispatch={dispatch}></GeneralGrid>
      </div>
      </div>
    </div>
  );
}

export default App;
